module.exports = __webpack_public_path__ + "static/img/009.ce96baf0.svg";